import { FormControl } from "@mui/material";
import { SimpleDropdown } from "../../../components/Basic/SimpleDropdown/SimpleDropdown";
import { styled } from "@mui/material/styles";

const FormControlBox = styled(FormControl)(({ theme }) => ({
  display: "flex",
  flexFlow: "row",
  maxWidth: theme.spacing(80),
  alignItems: "center",
  "&:nth-last-of-type(n+2)": {
    marginBottom: theme.spacing(1.875),
  }
}));

interface LanguageDropdownProps {
  value: any;
  onChange: (value: any) => void;

  options: { text: string; value: number }[];
  disabled?: boolean;
  error?: boolean;
}

const LanguageDropdown = ({
  value,
  onChange,
  options,
  disabled = false,
  error,
}: LanguageDropdownProps) => {
  return (
    <>
      <FormControlBox>
        <SimpleDropdown
          id="LanguageId"
          name="LanguageId"
          canRemoveAll={false}
          label={"Language"}
          onChange={onChange}
          placeholder=""
          options={options}
          value={value}
          variant="outlined"
          disabled={disabled}
          error={error}
        />
      </FormControlBox>
    </>
  );
};

export { LanguageDropdown };